import { getLastDayOfMonth } from '../../Utilities';

const convertDateFrom = (dateFrom: string) => {
  if (dateFrom && dateFrom.indexOf('M,') !== -1) {
    const months = dateFrom.toString().split('M,')[1].split(',');
    const monthsLength = months.length;
    if (monthsLength === 1) {
      const year = parseInt(months[0].split('-')[0], 10);
      const month = parseInt(months[0].split('-')[1], 10);
      const lastDayOfMonth = getLastDayOfMonth({ year, month });
      return `${months[0].replace(/-/g, '')}01-${months[0].replace(/-/g, '')}${lastDayOfMonth}`;
    } else {
      const year = parseInt(months[monthsLength - 1].split('-')[0], 10);
      const month = parseInt(months[monthsLength - 1].split('-')[1], 10);
      const lastDayOfMonth = getLastDayOfMonth({ year, month });
      return `${months[0].replace(/-/g, '')}01-${months[monthsLength - 1].replace(/-/g, '')}${lastDayOfMonth}`;
    }
  }
  return dateFrom?.replace(/-/g, '');
};

export default convertDateFrom;
